import { useAppDispatch } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";
import { Button } from "shared/ui/Button";
import { CloseIcon } from "shared/ui/Icons";
import { Portal } from "shared/ui/Portal";
import s from "./DeleteAllCardsModal.module.scss";

import { deleteAllCardsModalStore } from "../model/deleteAllCardsModal.store";

type DeleteAllCardsModalProps = {
  deleteAllCards: () => void;
};

export const DeleteAllCardsModal: RFC<DeleteAllCardsModalProps> = ({ deleteAllCards }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const closeModal = () => {
    dispatch(deleteAllCardsModalStore.actions.closeDeleteAllCardsModalAction());
  };

  return (
    <Portal className={s.modal} closePopup={closeModal}>
      <Button className={s.closeBtn} onClick={closeModal}>
        <CloseIcon />
      </Button>
      <div className={s.contentBox}>
        <div className={s.title}>{t("Are you sure you want to delete all of the listed shipments?")}</div>
        <div className={s.description}>{t("You will have to add new shipments from scratch")}.</div>
        <div className={s.buttonsWrapper}>
          <Button className={s.cancelButton} onClick={closeModal} size="small">
            {t("No, cancel")}
          </Button>
          <Button className={s.deleteButton} variant="primary" onClick={deleteAllCards} size="small">
            {t("Yes, delete all")}
          </Button>
        </div>
      </div>
    </Portal>
  );
};
